module.exports = __webpack_public_path__ + "img/Z61Q_15.7a8dd73e.jpg";